// extracted by mini-css-extract-plugin
export default {"host":"style_host__cYstw","brand":"style_brand__yFCqr","logo":"style_logo__dKCpi","body":"style_body__lWZfG","error":"style_error__pM7gJ"};